import { ConfigProvider, Switch, SwitchProps } from 'antd';
import styled from 'styled-components';

const SwitchV2 = (props: SwitchProps) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Switch: {
            colorPrimary: '#02D256',
            colorBorder: '#02D256',
            colorPrimaryHover: '#02D256',
          },
        },
      }}
    >
        <Switch checkedChildren="ON" unCheckedChildren="OFF" {...props} />
    </ConfigProvider>
  );
};

export default SwitchV2;
